// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2D9FD","checkboxCol":"Table_checkboxCol__2BTZQ","emailCol":"Table_emailCol__3-QGe","actionCol":"Table_actionCol__2Jij5"};